import { createStyles, makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            backgroundColor: "#008FC9",
            padding: '16px',
            width: '100%',
        },
        title: {
            color: 'white',
            fontWeight: 600,
            fontSize: 20
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row'
        },
        btnVoltar: {
            border: 'none',
            backgroundColor: '#ffffff00'
        },
        btnLogout: {
            position: 'absolute',
            top: 14,
            right: 15,
            border: 'none',
            backgroundColor: '#ffffff00'
        }
    })
) 